import React from 'react';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';

interface IStudioMetricValueTextProps {
  className?: string;
  value: string | number;
  formatRule: string;
  preFix?: string;
  endFix?: string;
  emptyText?: string;
}

export default function StudioMetricValueText(props: IStudioMetricValueTextProps) {
  const {
    className,
    value,
    formatRule,
    preFix = '',
    endFix = '',
    emptyText = '-',
  } = props;

  const isEmpty = value === '' || value === null || value === undefined;
  const display = isEmpty ? emptyText : `${preFix}${dataFormat({ value, formatRule })}${endFix}`;

  return <span className={className}>{display}</span>;
}
